import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z","key":"svg-1"}],["path",{"d":"M7 15v-6","key":"svg-2"}],["path",{"d":"M10 15v-6","key":"svg-3"}],["path",{"d":"M7 12h3","key":"svg-4"}]]

const IconBadgeHd = createReactComponent('outline', 'badge-hd', 'BadgeHd', __iconNode);

export default IconBadgeHd;